const MINUTE_IN_SECONDS = 60
const HOUR_IN_SECONDS = 3600
const DAY_IN_SECONDS = 86400
const MONTH_IN_SECONDS = 2629800
const YEAR_IN_SECONDS = 31557600

/**
 * Format number of seconds into year, month, day, hour, minute, seconds
 *
 * @param seconds
 */
const getTimePeriods = (seconds: string) => {
  let delta = Math.abs(parseInt(seconds, 10))
  const timeLeft = {
    years: 0 || '0',
    months: 0 || '0',
    days: 0 || '0',
    hours: 0 || '0',
    minutes: 0 || '0',
    seconds: 0 || '0',
  }

  if (delta >= YEAR_IN_SECONDS) {
    timeLeft.years = Math.floor(delta / YEAR_IN_SECONDS).toString()
    delta -= parseInt(timeLeft.years, 10) * YEAR_IN_SECONDS
  }

  if (delta >= MONTH_IN_SECONDS) {
    timeLeft.months = Math.floor(delta / MONTH_IN_SECONDS).toString()
    delta -= parseInt(timeLeft.months, 10) * MONTH_IN_SECONDS
  }

  if (delta >= DAY_IN_SECONDS) {
    timeLeft.days = Math.floor(delta / DAY_IN_SECONDS).toString()
    delta -= parseInt(timeLeft.days, 10) * DAY_IN_SECONDS
  }

  if (delta >= HOUR_IN_SECONDS) {
    timeLeft.hours = Math.floor(delta / HOUR_IN_SECONDS).toString()
    delta -= parseInt(timeLeft.hours, 10) * HOUR_IN_SECONDS
  }

  if (delta >= MINUTE_IN_SECONDS) {
    if (Math.floor(delta / MINUTE_IN_SECONDS) < 10) {
      timeLeft.minutes = `0${Math.floor(delta / MINUTE_IN_SECONDS)}`
    } else {
      timeLeft.minutes = Math.floor(delta / MINUTE_IN_SECONDS).toString()
    }
    delta -= parseInt(timeLeft.minutes, 10) * MINUTE_IN_SECONDS
  }

  timeLeft.seconds = delta < 10 ? `0${delta}` : delta.toString()

  // eslint-disable-next-line consistent-return
  return timeLeft
}

export default getTimePeriods
